<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <div class="home-title mt-4 card-title">
            The Welland Canal: Fourth Canal
            <v-btn text to="/TheWellandCanal">Go Back</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row wrap>
        <v-col lg="12" sm="12">
          <v-card>
            <v-card-text class="body-1">
              <h1>Fourth Canal</h1>
              <h2>Operation 1932 - present</h2>8 concrete locks
              <br />233.5 m (766 feet) long by 24.4 m (80 feet) wide
              <br />8.3 metres (27 feet) deep
              <br />

              <p>Plans were underway before the First World War to build another canal, this time with major changes. The Welland Ship Canal, as it was called, was for transportation purposes only, as water-powered mills and industries had become obsolete. Advances in engineering and the availability of electric pumps and motors to work the locks meant that the new canal would only have 8 locks. Other significant developments included a new entrance to the Welland Canal on Lake Ontario at Port Weller, and a new route with twinned, flight locks up the escarpment at Thorold, so the canal now follows an almost direct north-south route through the Niagara Peninsula. Although construction began in 1912, it was put on hold during the First World War, with the completed canal finally open for navigation in 1932. In 1959, the Welland Canal became part of the St. Lawrence Seaway.</p>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img contain src="../assets/images/Photo_1__Fourth_Canal_992_36_12.jpg"></v-img>

            <v-card-text class="body-1">The S.S. Lemoyne officially opened the complete Fourth Welland Canal on August 6, 1932 with its holds filled with 530,000 bushels of wheat. It was then the largest freighter on the Great Lakes.
Port Colborne Historical & Marine Museum 992.36.12</v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card>
            <v-img contain src="../assets/images/Photo_2___Fourth_Canal_978_36_18.jpg"></v-img>

            <v-card-text class="body-1">1945 photograph of the lift bridges at Port Colborne. The two vertical lift bridges were built in 1929 to allow automobiles, pedestrians and train passage over the wider channel of the fourth Welland Canal. One of the few remaining vertical lift bridges still in operation, Bridge 21 continues to accommodate vehicle and pedestrian traffic. Bridge 20, the Canadian National Railway bridge, was dismantled in 1997.
Port Colborne Historical & Marine Museum 978.36.18</v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card>
            <v-img contain src="../assets/images/Photo_3___Fourth_Canal_2006_31_2.jpg"></v-img>

            <v-card-text class="body-1">Coloured post card of the lift bridges at Port Colborne taken from West Street. West Street, at the base of the lift bridges, is the only location along the Welland Canal where you can still see evidence of all four channels of the Welland Canal together. The channel closest to West Street was the route taken by the first two Welland Canals. The indentations in the walls of the middle channel, the Third Welland Canal, are the remains of its guard lock gates. The large channel passing under the lift bridges is the Fourth Welland Canal. c. 1935
Port Colborne Historical & Marine Museum 2006.31.2</v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card>
            <v-img contain src="../assets/images/Photo_4__Fourth_Canal_979_79_1.jpg"></v-img>

            <v-card-text class="body-1">1952 aerial photograph of the fourth Welland Canal at Port Colborne. The two ships on the left are docked at Robin Hood Mill.
Port Colborne Historical & Marine Museum 979.79.1</v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card>
            <v-img contain src="../assets/images/Photo_5__Fourth_Canal_990_25_1.jpg"></v-img>

            <v-card-text class="body-1">The Fourth Canal at Port Colborne with several ships tied up in the harbour. The two ships at the front right were known as “whalebacks.” This unusual hull design was used on the Great Lakes to carry grain or ore.  These two ships are probably waiting to be towed to Hamilton for scrapping, c. 1960.
Port Colborne Historical & Marine Museum 990.25.1</v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card>
            <v-img contain src="../assets/images/Photo_6___Fourth_Canal_Ship_docked_West_St_976_281_2.jpg"></v-img>

            <v-card-text class="body-1">The Algosea tied up along West Street, c. 1970.  Many vessels berth at Port Colborne for off-season repairs.    
Port Colborne Historical & Marine Museum 976.281.2</v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card>
            <v-img contain src="../assets/images/Photo 7- Third Canal 992_17_4.jpg"></v-img>

            <v-card-text class="body-1">Postcard of the opening of Lock 8 at Humberstone in September 1929.  While the Fourth Welland Canal was not fully completed until 1932, the section at Port Colborne and Humberstone was in operation three years before, beginning in September 1929. The ship Meaford was the first vessel through the lock. The ship was downbound to Lake Ontario. Lock 8 is one of the longest locks in the world at 420.6 metres (1380 feet). A regulating lock, it raised or lowers ships 0.3 to 1.2 metres (1 to 4 feet) depending on the fluctuating levels of Lake Erie.
Port Colborne Historical & Marine Museum 982.47.20</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>
export default {
  name: "FourthCanal",
  components: {},
  data() {
    return {};
  },
};
</script>

<style>
</style>